import { Link } from 'react-router-dom';

import { assets, campaign, researchNotes } from './campaign';

function EndorsementsPage() {
  return (
    <main className="bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-black uppercase tracking-[0.2em] text-[#8f6400]">
            Endorsements and support
          </p>
          <h1
            className="mt-3 text-5xl font-black text-[#6f2182]"
            style={{ fontFamily: 'Source Serif 4, serif' }}
          >
            Trusted by public safety and local leaders.
          </h1>
          <p className="mt-5 text-lg leading-8 text-[#66546f]">
            Beau is proud to stand with the public safety organizations and local leaders who know
            Galveston, understand District 5, and share his commitment to responsive city service.
          </p>
        </div>

        <section className="mt-12 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <img
            src={assets.adTertiary}
            alt="Beau Rawlins endorsement campaign graphic"
            className="rounded-[2rem] bg-[#f8f1fb] object-cover shadow-xl"
          />
          <div className="grid gap-4 sm:grid-cols-2">
            {researchNotes.priorEndorsements.map((endorsement) => (
              <div key={endorsement} className="rounded-2xl bg-[#f8f1fb] p-6 shadow-lg">
                <p className="text-sm font-black uppercase tracking-[0.18em] text-[#8f6400]">
                  Endorsed by
                </p>
                <p className="mt-3 text-2xl font-black text-[#6f2182]">{endorsement}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 rounded-[2rem] bg-[#6f2182] p-8 text-center text-white shadow-xl">
          <h2 className="text-4xl font-black" style={{ fontFamily: 'Source Serif 4, serif' }}>
            Want to endorse Beau?
          </h2>
          <p className="text-white/78 mx-auto mt-4 max-w-2xl text-lg leading-8">
            Send a message to the campaign and we will follow up about endorsements, neighborhood
            events, signs, and volunteer opportunities.
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-block rounded-full bg-[#f5c400] px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#6f2182] shadow-lg transition hover:bg-white"
          >
            Contact us
          </Link>
        </section>
        <p className="mt-8 text-center text-sm text-[#6a7b89]">{campaign.paidFor}</p>
      </div>
    </main>
  );
}

export default EndorsementsPage;
